import { useCallback } from 'react'

const useScrolledToElement = ({ enabled = true }) => {
  return useCallback(node => {
    if (node != null && enabled) {
      node.scrollIntoView({ behavior: 'instant' })
      window.scrollBy({ top: -20, behavior: 'instant' })
    }
  }, [enabled])
}

export default useScrolledToElement
